export const ASSET_AVAILABILITY = 'ASSET_AVAILABILITY';
export const ASSET_SELECTION = 'ASSET_SELECTION';
export const CONTACT_PERSON = 'CONTACT_PERSON';
export const REASON_FOR_REPAIR = 'REASON_FOR_REPAIR';
export const REVIEW = 'REVIEW';
export const SERVICE_PROVIDER_SELECTION = 'SERVICE_PROVIDER_SELECTION';
export const SERVICE_REQUEST_TYPE = 'SERVICE_REQUEST_TYPE';
export const SERVICE_REQUEST_WIZARD = 'SERVICE_REQUEST_WIZARD';

export default [
  ASSET_AVAILABILITY,
  ASSET_SELECTION,
  CONTACT_PERSON,
  REASON_FOR_REPAIR,
  REVIEW,
  SERVICE_PROVIDER_SELECTION,
  SERVICE_REQUEST_TYPE,
  SERVICE_REQUEST_WIZARD,
];



// WEBPACK FOOTER //
// ./setup/WizardRegistry/constants.js